<template>
<div> This is the BP Odds App</div>
</template>

<script setup>

</script>

<style scoped>

</style>
